import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Button } from 'primereact/button';
import { Toast } from "primereact/toast";

// ------------------ COMPONENTES DE BASE--------------------------
import AgGrid from "../../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../../../../Base/Services/ToastService";
import { getLabel } from "../../../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../../../Base/Context/ConfigContext/ConfigContext";

// ------------------- CONSULTAS A LA API---------------------------
import { ObtenerIngresosParaDevoluciones, ObtenerIngresosT } from "../../../../../../API/Suministros/IngresosBodega/IngresosBodegaDetalleRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import AgregarDevolucionProveedor from "./AgregarDevolucionProveedor";
import OrdenesComprasCrud from "../../../../Compras/OrdenesCompras/CrudOrdenesCompras/OrdenesComprasCrud";
import ModalFull from "../../../../../../Base/Components/Dialog/ModalFull";
import { confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import IngresosBodegaCrud from "../../IngresosBodega/IngresosCRUD/IngresosBodegaCrud";
import CalendarWeek from "../../../../../../Base/Components/Form/CalendarWeek";
import { getDatesProduccion } from "../../../../../../Base/Services/Moment/Luxon";

const ListadoDevolucionesProveedorCRUD = ({
    actualizarScreen
  }) => {
    const toastRef = useRef(null);
    const { userAuth } = useContext(AuthContext);
    const { config } = useContext(ConfigContext);
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState([]); 
    const [showDialogDI, setShowDialogDI] = useState(false);
    const [ingresoToShow, setIngresoToShow] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    const [listadoI, setListadoI] = useState(null);  
    const [ordenDialog, setOrdenDialog] = useState(false);
    const [orderToShow, setOrderToShow] = useState(null);
    const [habilitar, setHabilitar] = useState(true);
    const [dates, setDates] = useState([new Date(), new Date()]);

    const [hiddenPriceColumn, setHiddenPriceColumn] = useState(
      userAuth.AccessWeb.split(",")
        .map((e) => parseInt(e))
        .includes(29)
    );


    const getInfoCrud = async () => {
      if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
        toastShow( toastRef, "warn", "Advertencia", "Por favor, seleccione un rango de fechas válido." );
        return;
      }
      setLoading(true)
      const fechas = getDatesProduccion(dates);
      const lista = await ObtenerIngresosParaDevoluciones(fechas)
      setListadoI(lista)
      setLoading(false)
    };

    const OrdenC = (Id) => {
      setOrderToShow(Id);
      setOrdenDialog(true);
      // showModal();
    };

    const showModal = () => {
      // setOrdenDialog(true);
    };
  
  
    const columns = [
      {
        header: "ID",
        headerEn: "ID",
        field: "IdIngresoDetalle",
        frozen: true,
        className: "XXsmall",
        hidden: userAuth.IdRol === 1,
      },
      {
        header: "Fecha Ingreso",
        headerEn: "Date Entry",
        field: "FechaIngreso",
        Format: "DateTime",
        frozen: true,
      },
      {
        header: "Estado",
        headerEn: "Status",
        field: "StatusName",
        frozen: true,
        className: "small",
        // cellEditor: changeEstado,
        Format: "Estado",
        body: (rowData) => ({
          ID: rowData?.IdEstado,
          Estado: rowData?.StatusName,
        }),
      },
      {
        header: "Orden Compra",
        headerEn: "Purchase Order",
        field: "PurchaseOrder",
        frozen: true,
        className: "small",
        align: "center",
        Format: "Modal",
        onCellDoubleClicked: ({ data }) => {
          OrdenC(data.PurchaseOrder);
        },
      },
      {
        header: "Producto",
        headerEn: "Product",
        field: "CodigoProducto",
        className: 'Xsmall'
      },
      {
        header: "Producto",
        className: 'medium',
        headerEn: "Product",
        field: "NombreProducto",
      },
      {
        header: "DescripcionProducto",
        headerEn: "Description",
        field: "Descripción",
      },
      {
        header: "Tipo Producto",
        headerEn: "Product Type",
        className: 'small',
        field: "NombreCategoria",
      },
      {
        className: 'small',
        header: "Categoría",
        headerEn: "Category",
        field: "NombreSubcategoria",
      },
      {
        header: "SubCategoría",
        className: 'small',
        headerEn: "SubCategory",
        field: "NombreTipoProducto",
      },
      {
        header: "Tipo Ingreso",
        className: 'small',
        headerEn: "Type",
        field: "Type",
      },
      {
        header: "No. Ingreso",
        headerEn: "No. Ingreso",
        field: "NumeroIngreso",
        className: "small",
        align: "center",
        Format: "Modal",
        onCellDoubleClicked: ({ data }) => {

          setIngresoToShow(data?.NumeroIngreso)
          setShowDialog(true)
          // OrdenC(data.PurchaseOrder);
        },
      },
      {
        header: "Moneda",
        className: "Xsmall",
        headerEn: "Currency",
        field: "Currency",
      },
      {
        header: "Unidad",
        className: "Xsmall",
        headerEn: "Unit",
        field: "UnitName",
      },
      {
        header: "Bodega",
        headerEn: "Warehouse",
        field: "NombreBodega",
      },
      {
        className: "Xsmall",
        header: "Estante",
        headerEn: "Shelf",
        field: "NombreEstante",
      },
      {
        className: "Xsmall",
        header: "Posición",
        headerEn: "Position",
        field: "NombrePosicion",
      },
      {
        className: "Xsmall",
        header: "Bandeja",
        // headerEn: "Position",
        field: "NombreBandeja",
      },
      {
        header: "Tasa Cambio",
        headerEn: "Exchange Rate",
        field: "TasaCambio",
        hidden: hiddenPriceColumn,
        Format: "Currency",
        Sumary: "sum",
        className: "small",
      },
      {
        header: "Inventario",
        Sumary: "sum",
        headerEn: "Inventory",
        field: "Inventario",
        Format: "Currency",
        className: "small",
      },
      {
         headerName: 'Lempiras',
         children: [
          {
            header: "Precio L",
            headerEn: "Price L",
            Sumary: "sum",
            field: "PrecioL",
            hidden: hiddenPriceColumn,
            Format: "Currency",
            className: "small",
          },
          {
            header: "SubTotal L",
            headerEn: "SubTotal",
            field: "SubTotal",
            Sumary: "sum",
            hidden: hiddenPriceColumn,
            Format: "Currency",
            className: "small",
          },
          {
            header: "ISV L",
            headerEn: "TAX L",
            field: "ISVProductoL",
            Sumary: "sum",
            hidden: hiddenPriceColumn,
            Format: "Currency",
            className: "small",
          },
          {
            header: "Descuento",
            headerEn: "Discount",
            Sumary: "sum",
            field: "Descuento",
            hidden: hiddenPriceColumn,
            Format: "Currency",
            className: "small",
          },
        ]
      },
      {
        headerName: 'Dolares',
        children: [
          {
            header: "Precio D",
            Sumary: "sum",
            headerEn: "Price D",
            field: "PrecioD",
            hidden: hiddenPriceColumn,
            Format: "Currency",
            className: "small",
          },
          {
            header: "SubTotal D",
            headerEn: "SubTotal D",
            field: "SubTotalD",
            Sumary: "sum",          
            hidden: hiddenPriceColumn,
            Format: "Currency",
            className: "small",
          },
          {
            header: "ISV D",
            headerEn: "TAX D",
            field: "ISVProductoD",
            Sumary: "sum",
            hidden: hiddenPriceColumn,
            Format: "Currency",
            className: "small",
          },
          {
            header: "Descuento D",
            headerEn: "Discount D",
            Sumary: "sum",
            field: "DescuentoD",
            hidden: hiddenPriceColumn,
            Format: "Currency",
            className: "small",
          },

        ]
      },

      {
        header: "Ingreso",
        headerEn: "Income",
        field: "Ingreso",
        Format: "Currency",
        frozen: true,
        alignFrozen: "right",
        className: "Xsmall",
      },
      {
        header: "Balance",
        headerEn: "Balance",
        field: "BalanceDevolucion",
        Format: "Currency",
        frozen: true,
        alignFrozen: "right",
        className: "Xsmall",
      },
      {
        header: "Monto L",
        headerEn: "Amount L",
        Sumary: "sum",
        field: "MontoL",
        hidden: hiddenPriceColumn,
        Format: "Currency",
        className: "small",        
        frozen: true,
        alignFrozen: "right",
      },
      {
        header: "Monto D",
        headerEn: "Amount D",
        field: "MontoD",
        hidden: hiddenPriceColumn,
        Sumary: "sum",
        Format: "Currency",        
        frozen: true,
        alignFrozen: "right",
        className: "small",
      },
      {
        field: "",
        className: "colum-width-small",
        header: "",
        Format: "Botones",
        filter: false,
        frozen: true,
        alignFrozen: "right",
        Botones: [
          {
            icon: "pi pi-plus",
            tooltip: "Agregar Salida",
            onClick: (rowData) => {
              if(rowData?.IdIngresoDetalle){
                setShowDialogDI(true);
                setSelected([rowData]);
              }
            },
            tooltipOptions: {
              position: "right",
            },
          },
        ],
      },
      // {
      //   header: "Embalaje L",
      //   headerEn: "Packaging L",
      //   field: "EmbalajeL",
      //   hidden: userAuth.IdRol === 1,
      //   Sumary: "sum",
      //   Format: "Currency",
      //   className: "small",
      // },
      // {
      //   header: "Embalaje D",
      //   headerEn: "Packaging D",
      //   field: "EmbalajeD",
      //   hidden: userAuth.IdRol === 1,
      //   Format: "Currency",
      //   Sumary: "sum",
      //   className: "small",
      // },
      // {
      //   header: "Desaduanaje L",
      //   headerEn: "Customs Clearance L",
      //   field: "DesaduanajeL",
      //   Format: "Currency",
      //   Sumary: "sum",
      //   className: "small",
      //   hidden: userAuth.IdRol === 1,
      // },
      // {
      //   header: "Desaduanaje D",
      //   Sumary: "sum",
      //   headerEn: "Customs Clearance D",
      //   field: "DesaduanajeD",
      //   Format: "Currency",
      //   className: "small",
      //   hidden: userAuth.IdRol === 1,
      // },
      // {
      //   header: "Flete L",
      //   headerEn: "Freight L",
      //   field: "FleteL",
      //   Sumary: "sum",
      //   Format: "Currency",
      //   className: "small",
      //   hidden: userAuth.IdRol === 1,
      // },
      // {
      //   header: "Flete D",
      //   Sumary: "sum",
      //   headerEn: "Freight D",
      //   field: "FleteD",
      //   Format: "Currency",
      //   className: "small",
      //   hidden: userAuth.IdRol === 1,
      // },
      // {
      //   header: "Precio UL",
      //   headerEn: "Price UL",
      //   Sumary: "sum",
      //   field: "PrecioUL",
      //   Format: "Currency",
      //   className: "small",
      //   hidden: userAuth.IdRol === 1,
      // },
      // {
      //   header: "Precio UD",
      //   headerEn: "Price UD",
      //   className: "small",
      //   Sumary: "sum",
      //   field: "PrecioUD",
      //   Format: "Currency",
      //   className: "small",
      //   hidden: userAuth.IdRol === 1,
      // },
      // {
      //   header: "Otros Costos L",
      //   headerEn: "Other Costs L",
      //   field: "OtrosCostosL",
      //   Sumary: "sum",
      //   Format: "Currency",
      //   className: "small",
      //   hidden: userAuth.IdRol === 1,
      // },
      // {
      //   Sumary: "sum",
      //   header: "Otros Costos D",
      //   headerEn: "Other Costs D",
      //   field: "OtrosCostosD",
      //   Format: "Currency",
      //   className: "small",
      //   hidden: userAuth.IdRol === 1,
      // },
      // {
      //   header: "Costo L",
      //   Sumary: "sum",
      //   headerEn: "Cost L",
      //   field: "CostoL",
      //   hidden: userAuth.IdRol === 1,
      // },
      // {
      //   Sumary: "sum",
      //   header: "Costo D",
      //   headerEn: "Cost D",
      //   field: "CostoD",
      //   hidden: userAuth.IdRol === 1,
      // },
    ];
  
    const table = {
      Columns: columns,
      Data: listadoI,
      loading: loading,
      selected: selected,
      setSelected: (e) => setSelected(e),
      showModal: (e) => showModal(e),
    };

    const cerrarIngresosBodega = () => {
      // Mostrar confirmación si hay ediciones sin guardar
      if (habilitar && orderToShow !== null) {
        confirmDialog({
          message: "¿Estás seguro de cerrar sin guardar los cambios?",
          header: "Cerrar sin guardar",
          icon: "pi pi-exclamation-triangle",
          acceptLabel: "Sí",
          accept: () => {
            setOrdenDialog(null);
            setOrderToShow(null); // Cerrar el diálogo
          },
          rejectLabel: "No",
          reject: () => {}, // No hacer nada si el usuario cancela
          style: { backgroundColor: "white" },
        });
      } else {
        setOrdenDialog(null);
        setOrderToShow(null);
        setHabilitar(true);
      }
    };

    const cerrarConfirmacion = () => {
      // Mostrar confirmación si hay ediciones sin guardar
      if (habilitar && ingresoToShow !== null) {
        confirmDialog({
          message: "¿Estás seguro de cerrar sin guardar los cambios?",
          header: "Cerrar sin guardar",
          icon: "pi pi-exclamation-triangle",
          acceptLabel: "Sí",
          accept: () => {
            setShowDialog(null);
            setShowDialog(null); // Cerrar el diálogo
          },
          rejectLabel: "No",
          reject: () => {}, // No hacer nada si el usuario cancela
          style: { backgroundColor: "white" },
        });
      } else {
        setShowDialog(null);
        setIngresoToShow(null);
        setHabilitar(true);
      }
    };

    useEffect(() => {
      getInfoCrud();
    }, []);
    
    
    return (
      <div>
        <Toast ref={toastRef} />
        <div className="d-flex gap-2 m-2">
          <h2>
            {getLabel(baseLang, "listadoIngresosDevPro", config.language)}
          </h2>
          <div className="botones">
            <CalendarWeek
              date={dates}
              setDate={setDates}
              buscar={getInfoCrud}
              selectionMode="range"
            />
            <Button
              icon="pi pi-plus"
              className="mx-2"
              tooltip="Nueva"
              onClick={(e) => {
                if (selected.length === 0) {
                  toastShow(
                    toastRef,
                    "warn",
                    "Advertencia",
                    "Seleccione un Ingreso"
                  );
                  return;
                } else {
                  setShowDialogDI(true);
                }
              }}
            />
          </div>
        </div>

        <div id="Dialog" style={{ height: "76vh" }}>
          <AgGrid table={table} />
        </div>

        <ModalFull
          header="Orden de compras"
          visible={ordenDialog}
          onHide={() => {
            cerrarIngresosBodega();
          }}
          contenido={
            <OrdenesComprasCrud
              PurchaseOrder={orderToShow}
              setOrderToShow={setOrderToShow}
              ordenDialog={ordenDialog}
              setOrdenDialog={setOrdenDialog}
              habilitar={habilitar}
              setHabilitar={setHabilitar}
            />
          }
        />

        {showDialogDI && (
          <AgregarDevolucionProveedor
            selected={selected}
            setSelected={setSelected}
            showDialogDI={showDialogDI}
            setShowDialogDI={setShowDialogDI}
            getInfo={getInfoCrud}
            actualizarScreen={actualizarScreen}
          />
        )}


      <Dialog
        visible={showDialog}
        onHide={() => {
          cerrarConfirmacion()
        }}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <IngresosBodegaCrud
          idIngreso={ingresoToShow}
          setIngresoToShow={setIngresoToShow}
          showDialog={showDialog}
          // setOrderToShow={setIngresoToShow}
          setOrdenDialog={setOrdenDialog}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
        />
      </Dialog>


      </div>
    );
  };
  
  export default ListadoDevolucionesProveedorCRUD;
  
